import React from 'react';
import { Mail } from 'lucide-react';
import { ArrowLeft, Phone, MapPin, Clock, FileText } from '../components/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Contacto() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const contactInfo = [
    {
      icon: Mail,
      title: 'Email',
      content: 'informatica@vicsa.cl',
      description: 'Informática'
    },
    {
      icon: Phone,
      title: 'Teléfono',
      content: '+56 9 8777 4448',
      description: 'Lunes a Viernes 8:30 - 18:00'
    },
    {
      icon: MapPin,
      title: 'Dirección',
      content: 'Av. del Valle Norte 787 (piso 5), Huechuraba',
      description: 'Santiago de Chile'
    },
    {
      icon: Clock,
      title: 'Horario',
      content: '8:30 - 18:00',
      description: 'Lunes a Viernes'
    }
  ];

  /* Opción de Chat eliminada */
  /* Opción de Chat eliminada */
  /* Documentación solo visible para admin, soporte, sap */
  const supportOptions = [
    {
      title: 'Documentación',
      description: 'Consulta la documentación completa del sistema',
      icon: FileText,
      action: () => navigate('/docs'),
      color: 'from-green-500 to-green-600',
      allowedRoles: ['admin', 'soporte', 'sap']
    }
  ].filter(option => {
    if (option.allowedRoles) {
      return option.allowedRoles.includes(user?.role?.toLowerCase());
    }
    return true;
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 py-8">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header */}
        <div className="mb-8 flex flex-col items-center">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4 text-center">
            📞 Contacto - HelpDesk
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mb-6 text-center max-w-2xl">
            Estamos aquí para ayudarte. Contáctanos a través de nuestros canales oficiales.
          </p>
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center space-x-2 px-4 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Volver</span>
          </button>
        </div>

        {/* Información de Contacto Centralizada */}
        <div className="space-y-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {contactInfo.map((info, index) => (
              <div
                key={index}
                className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 border border-gray-200 dark:border-gray-700 hover:shadow-lg transition-shadow"
              >
                <div className="flex items-start space-x-4">
                  <div className="p-3 bg-blue-100 dark:bg-blue-900 rounded-lg">
                    <info.icon className="w-6 h-6 text-blue-600 dark:text-blue-400" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-white mb-1">
                      {info.title}
                    </h3>
                    <p className="text-lg font-medium text-gray-900 dark:text-white">
                      {info.content}
                    </p>
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                      {info.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Otras Opciones de Soporte */}
          <div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 text-center">
              Otras Opciones
            </h3>
            <div className="max-w-md mx-auto">
              {supportOptions.map((option, index) => (
                <button
                  key={index}
                  onClick={option.action}
                  className="w-full bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 border border-gray-200 dark:border-gray-700 hover:shadow-lg transition-all duration-200 hover:scale-105 text-left"
                >
                  <div className="flex items-center space-x-4">
                    <div className={`p-3 rounded-lg bg-gradient-to-r ${option.color} text-white`}>
                      <option.icon className="w-6 h-6" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 dark:text-white mb-1">
                        {option.title}
                      </h4>
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        {option.description}
                      </p>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Footer Info */}
        <div className="mt-12 bg-blue-50 dark:bg-blue-900/20 rounded-2xl p-8 text-center">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            ¿Urgencia?
          </h3>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Para problemas críticos que detienen la operación, contáctanos directamente por teléfono.
          </p>
          <div className="flex justify-center">
            <a
              href="tel:+56987774448"
              className="inline-flex items-center px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
            >
              <Phone className="w-5 h-5 mr-2" />
              Llamar Ahora
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
